var FastqFileType = {
  WT_FASTQ: 'wtFastq',
  IMMUNE_FASTQ: 'immuneFastq'
};
export default FastqFileType;